module.exports = __webpack_public_path__ + "img/dashboard-active.259a9d1c.svg";